import { useCallback, useMemo, useState } from 'react';
import useObjectKeysMemoize from './useObjectKeysMemoize.js';
import { EMPTY_OBJ, ForgotPasswordDefaultProps } from '../Constants.js';
import { defaultOnResetPassword } from '../Util.js';
export default function useForgotPassword(opts) {
  const {
    classNames = EMPTY_OBJ,
    variants: pVariants,
    options: pOptions,
    components: pComponents,
    onResetPassword = defaultOnResetPassword,
    onBackToLogin,
    onAfterForgotPassword,
    onForgotPasswordError,
    ...restProps
  } = opts;
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...ForgotPasswordDefaultProps.variants,
      ...v
    };
  }, [v]);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...ForgotPasswordDefaultProps.options,
      ...o
    };
  }, [o]);
  const c = useObjectKeysMemoize(pComponents);
  const components = useMemo(() => {
    return {
      ...ForgotPasswordDefaultProps.components,
      ...c
    };
  }, [c]);
  const rest = useObjectKeysMemoize(restProps);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [submitted, setSubmitted] = useState();
  const onSubmit = useCallback(({
    email
  }) => {
    setLoading(true);
    setError(null);
    const prom = onResetPassword?.(email.trim());
    if (prom?.then) {
      prom.then((...args) => {
        setSubmitted(true);
        return onAfterForgotPassword?.(...args);
      }).catch(err => {
        setError(err);
        onForgotPasswordError?.(err);
      }).finally(() => {
        setLoading(false);
      });
    } else {
      setSubmitted(true);
      setLoading(false);
    }
  }, [onResetPassword, onAfterForgotPassword, onForgotPasswordError]);
  return useMemo(() => {
    return {
      classNames,
      variants,
      options,
      components,
      onResetPassword,
      onBackToLogin,
      state: {
        loading,
        setLoading,
        error,
        setError,
        onSubmit,
        submitted
      },
      ...rest
    };
  }, [classNames, variants, options, components, onResetPassword, error, loading, onSubmit, onBackToLogin, submitted, rest]);
}